import './App.scss'
import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import Home from './components/Home/Home'
import About from './components/About/About'
import Contact from './components/Contact/Contact'
import Portfolio from './components/Portfolio/Portfolio'
// import { CssBaseline, StyledEngineProvider } from '@mui/material'
// import { StyledEngineProvider } from '@mui/material'

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" index element={<About />} />
          <Route path="contact" index element={<Contact />} />
          <Route path="portfolio" index element={<Portfolio />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
